module.exports = __webpack_public_path__ + "img/logo.17eee3d1.png";